<script lang="ts">
  import {isShowSearchLoader, pagination} from '../../../../stores'
  import { infiniteScrollHandler } from '../../services'
  import IniniteScroll from '../../../../custom/IniniteScroll.svelte'
</script>

{#if $pagination}
  <IniniteScroll 
    hasNext={$pagination.has_next}
    loading={$isShowSearchLoader}
    on:load={infiniteScrollHandler}
  />
{/if}